/**
 * @fileoverview Identity fields for member number, commercial name, legal name, and RFC.
 */

import { ReactComponent as CompanyIcon } from "../../../assets/icons/CorporateIdentity/CompanyIcon.svg";
import { ReactComponent as MemberNumberIcon } from "../../../assets/icons/CorporateIdentity/MemberNumberIcon.svg";
import {
  isFieldReadOnlyForProfile,
  shouldHideFieldForProfile,
} from "../../../utils/common";
import styles from "./CorporateIdentity.module.css";
import {
  CURSOR_NOT_ALLOWED,
  NOT_VISIBLE_FIELD_MESSAGE_KEY,
} from "./corporateIdentityConstants";

export default function CorporateIdentityFields({
  company,
  selectedProfile,
  section,
}) {
  const {
    t,
    isMobile,
    razonSocial,
    setRazonSocial,
    fieldValues,
    getErrorMessage,
    getFieldValidationState,
    handleValidatedFieldChange,
    handleInputChange,
  } = section;

  return (
    <div
      className={`${styles.inputRow} ${selectedProfile !== 0 ? styles.reducedFieldsRow : ""}`}
    >
      {!shouldHideFieldForProfile("numeroSocio", selectedProfile) && (
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t("components.corporateIdentity.memberNumberLabel")}
          </label>
          <div className={styles.inputWrapper}>
            <MemberNumberIcon className={styles.inputIcon} />
            <input
              type="text"
              className={`${styles.input} ${styles.inputWithIcon}`}
              placeholder={t(
                "components.corporateIdentity.memberNumberPlaceholder",
              )}
              value={company?.numeroSocio || ""}
              disabled={true}
              style={{ cursor: CURSOR_NOT_ALLOWED }}
            />
          </div>
          <p className={styles.notVisibleFieldMessage}>
            *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
          </p>
        </div>
      )}
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.corporateIdentity.commercialNameLabel")}
          <span className={styles.required}> *</span>
        </label>
        <div className={styles.inputWrapper}>
          <CompanyIcon className={styles.inputIcon} />
          <input
            type="text"
            className={`${styles.input} ${styles.inputWithIcon} ${
              getFieldValidationState(
                "nombreComercial",
                fieldValues.nombreComercial,
              ) === "error"
                ? styles.inputError
                : ""
            }`}
            placeholder={t(
              "components.corporateIdentity.commercialNamePlaceholder",
            )}
            value={fieldValues.nombreComercial}
            onChange={(e) =>
              handleValidatedFieldChange("nombreComercial", e.target.value)
            }
            maxLength={100}
            disabled={isFieldReadOnlyForProfile(
              "nombreComercial",
              selectedProfile,
            )}
            style={
              isFieldReadOnlyForProfile("nombreComercial", selectedProfile)
                ? { cursor: CURSOR_NOT_ALLOWED }
                : {}
            }
          />
        </div>
        {getErrorMessage("nombreComercial") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("nombreComercial")}
          </p>
        )}
      </div>
      {!shouldHideFieldForProfile("razonSocial", selectedProfile) && (
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t("components.corporateIdentity.socialReasonLabel")}
          </label>
          <div className={styles.inputWrapper}>
            <CompanyIcon className={styles.inputIcon} />
            <input
              type="text"
              className={`${styles.input} ${styles.inputWithIcon}`}
              placeholder={t(
                "components.corporateIdentity.socialReasonPlaceholder",
              )}
              value={razonSocial}
              onChange={(e) => {
                setRazonSocial(e.target.value);
                handleInputChange("razonSocial", e.target.value);
              }}
              disabled={true}
            />
          </div>
        </div>
      )}
      <div
        className={`${styles.inputGroup} ${
          isMobile ? styles.mobileTopSpacing : ""
        }`}
      >
        <label className={styles.inputLabel}>
          {t("components.corporateIdentity.RFCLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${styles.inputWithoutIcon}`}
          placeholder={t("components.corporateIdentity.RFCPlaceholder")}
          value={company?.RFC || ""}
          disabled={true}
          style={{ cursor: CURSOR_NOT_ALLOWED }}
          onChange={(e) => handleInputChange("RFC", e.target.value)}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
    </div>
  );
}
